/* Almla redesign: Build-a-Bundle page (sections/alm-bundle.liquid).
   Keeps the picked pairs in memory, shows the tier reached, and adds the whole
   bundle to the real cart in one /cart/add.js call, then opens the cart
   drawer. Every line gets the same hidden _bundle property, plus Rebuy's
   bundle builder properties when data-rebuy-bundle is set, so Rebuy's
   discount function applies the tier saving.
   Filters, sort and search mirror the Shop All grid (assets/alm-collection.js):
   collection, colour, cuff, the same colour merge and the same Featured
   ranking. Each card's photos: the second on hover, arrows and swipe for the
   rest. */
(function () {
  var root = document.querySelector("[data-bb]");
  if (!root || !root.querySelector("[data-bb-grid]")) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  function money(cents) {
    var v = Math.round(cents || 0) / 100;
    return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  var MAX = +root.getAttribute("data-max") || 6;
  var TIERS = $$("[data-bb-tiers] li").map(function (li) {
    return { n: +li.getAttribute("data-n"), off: +li.getAttribute("data-off"), el: li };
  }).filter(function (t) { return t.n > 0; }).sort(function (a, b) { return a.n - b.n; });
  var MIN = TIERS.length ? TIERS[0].n : 2;
  var grid = $("[data-bb-grid]");
  var cards = $$("[data-bb-card]");
  var byH = {};
  cards.forEach(function (c, i) { byH[c.getAttribute("data-h")] = c; c._i = i; });
  var pick = {}, order = [];

  function count() { return order.length; }
  function tier(n) {
    var t = null;
    TIERS.forEach(function (x) { if (n >= x.n) t = x; });
    return t;
  }
  function next(n) { return TIERS.filter(function (x) { return x.n > n; })[0]; }
  function pairs(n) { return n + " pair" + (n === 1 ? "" : "s"); }

  function set(h, d) {
    var n = count();
    if (!byH[h]) return;
    if (d > 0 && n >= MAX) return;
    if (d > 0) { order.push(h); pick[h] = (pick[h] || 0) + 1; }
    else if (pick[h]) {
      order.splice(order.lastIndexOf(h), 1);
      if (!--pick[h]) delete pick[h];
    }
    render();
  }

  function render() {
    var n = count(), full = n >= MAX;
    cards.forEach(function (c) {
      var h = c.getAttribute("data-h"), k = pick[h] || 0;
      var add = $("[data-bb-add]", c), qty = $(".bb-qty", c);
      c.classList.toggle("is-picked", k > 0);
      add.hidden = k > 0;
      qty.hidden = !k;
      $("[data-bb-n]", c).textContent = k;
      add.disabled = full;
      $("[data-bb-inc]", c).disabled = full;
    });

    var sub = order.reduce(function (s, h) { return s + +byH[h].getAttribute("data-p"); }, 0);
    var t = tier(n), nx = next(n);
    var save = t ? Math.round(sub * t.off / 100) : 0;
    TIERS.forEach(function (x) { x.el.classList.toggle("is-on", t === x); });

    var msg;
    if (!n) msg = TIERS.length ? "Pick " + MIN + " or more pairs to start saving." : "Pick your pairs to build a bundle.";
    else if (!t && nx) msg = "Add " + (nx.n - n) + " more pair" + (nx.n - n > 1 ? "s" : "") + " to save " + nx.off + "%.";
    else if (t && nx) msg = "You're saving " + t.off + "%. Add " + (nx.n - n) + " more to save " + nx.off + "%.";
    else if (t) msg = "You're saving " + t.off + "%, our best bundle price.";
    else msg = pairs(n) + " in your bundle.";
    if (full) msg += " Your bundle is full.";
    $("[data-bb-msg]").textContent = msg;

    // The bar runs to the top tier (6 pairs), with the grip sock pointer riding
    // the end of the fill, as on the cart's bar.
    var top = TIERS.length ? Math.max(TIERS[TIERS.length - 1].n, 1) : MAX;
    var pct = Math.min(100, n / top * 100);
    $("[data-bb-bar]").style.width = pct + "%";
    var th = $("[data-bb-thumb]"); if (th) th.style.left = pct + "%";
    $("[data-bb-total-n]").textContent = pairs(n) + (t ? " · Save " + t.off + "%" : "");

    var slots = "";
    for (var i = 0; i < Math.max(MAX, n); i++) {
      var h = order[i], c = h && byH[h];
      slots += c
        ? '<li class="is-full"><img src="' + esc(c.getAttribute("data-i")) + '" alt=""><span>' + esc(c.getAttribute("data-t")) + '</span>' +
          '<button type="button" data-bb-rm="' + i + '" aria-label="Remove ' + esc(c.getAttribute("data-t")) + '">&times;</button></li>'
        : '<li><span class="bb-slot-n">' + (i + 1) + "</span></li>";
    }
    $("[data-bb-slots]").innerHTML = slots;
    $("[data-bb-mini]").innerHTML = order.slice(0, MAX).map(function (h) {
      return '<img src="' + esc(byH[h].getAttribute("data-i")) + '" alt="">';
    }).join("");

    $("[data-bb-sub]").textContent = money(sub);
    $("[data-bb-saverow]").hidden = !save;
    $("[data-bb-save]").textContent = "−" + money(save);
    $("[data-bb-tot]").textContent = money(sub - save);

    var go = $("[data-bb-go]");
    go.disabled = n < MIN;
    go.textContent = n < MIN ? "Pick " + (MIN - n) + " more pair" + (MIN - n > 1 ? "s" : "") : "Add Bundle to Cart · " + money(sub - save);
  }

  function submit(btn) {
    var id = "B" + Date.now().toString(36).toUpperCase();
    var rb = root.getAttribute("data-rebuy-bundle");
    var sid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : id + "-" + Math.random().toString(36).slice(2);
    var items = Object.keys(pick).map(function (h) {
      var props = { _bundle: id };
      if (rb) {
        props._r_bbsi = 0;
        props._r_added_bundle_session_id = sid;
        props._source = "Rebuy";
        props._widget_id = rb;
        props._attribution = "Rebuy Bundle Builder";
      }
      return { id: +byH[h].getAttribute("data-v"), quantity: pick[h], properties: props };
    });
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    btn.disabled = true;
    btn.textContent = "Adding…";
    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      pick = {}; order = [];
      tray(false);
      render();
      if (window.AlmCart) { AlmCart.refresh(); AlmCart.open(); }
      else location.href = ROOT + "cart";
    }).catch(function (err) {
      render();
      $("[data-bb-msg]").textContent = (err && (err.description || err.message)) || "Your bundle could not be added. Please try again.";
    });
  }

  function tray(open) {
    root.classList.toggle("bb-open", open);
    document.documentElement.classList.toggle("bb-tray-open", open);
    $("[data-bb-toggle]").setAttribute("aria-expanded", open);
  }

  /* ---- Photos, as the shared card's slider (assets/alm-cards.js): a
     scroll-snap track that swipes on touch, the second photo fading in on
     hover (that counts as photo 2, so the next arrow goes on to photo 3), a
     pair of small arrows with a mouse, and a thin progress line. Photos past
     the second load on first hover, touch or swipe. ---- */
  function hydrate(c) {
    if (c._hyd) return;
    c._hyd = true;
    $$("img[data-src]", c).forEach(function (im) { im.src = im.getAttribute("data-src"); im.removeAttribute("data-src"); });
  }
  function track(c) { return $("[data-bb-track]", c); }
  function npics(c) { return $$(".bb-pic", c).length; }
  function idx(c) { var t = track(c); return t && t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0; }
  function paint(c) {
    var fig = $(".bb-fig", c), n = npics(c), i = idx(c);
    if (i === 0 && fig.classList.contains("is-hover") && !fig.classList.contains("is-moved") && n > 1) i = 1;
    fig.style.setProperty("--i", i);
    fig.classList.toggle("is-first", i === 0);
    fig.classList.toggle("is-last", i >= n - 1);
  }
  function show(c, dir) {
    var t = track(c), fig = $(".bb-fig", c), n = npics(c);
    if (n < 2) return;
    hydrate(c);
    var i = idx(c);
    if (i === 0 && fig.classList.contains("is-hover") && !fig.classList.contains("is-moved")) i = 1;
    var to = Math.max(0, Math.min(n - 1, i + dir));
    fig.classList.add("is-moved");
    t.scrollTo({ left: to * t.clientWidth, behavior: "smooth" });
    fig.style.setProperty("--i", to);
    fig.classList.toggle("is-first", to === 0);
    fig.classList.toggle("is-last", to >= n - 1);
  }
  cards.forEach(function (c) {
    var fig = $(".bb-fig", c), t = track(c);
    paint(c);
    if (npics(c) < 2) return;
    fig.addEventListener("pointerenter", function (e) {
      if (e.pointerType !== "mouse") return;
      fig.classList.add("is-hover"); hydrate(c); paint(c);
    });
    fig.addEventListener("pointerleave", function () {
      fig.classList.remove("is-hover");
      if (idx(c) === 0) fig.classList.remove("is-moved");
      paint(c);
    });
    fig.addEventListener("touchstart", function () { hydrate(c); }, { passive: true });
    var raf = 0;
    t.addEventListener("scroll", function () {
      hydrate(c);
      if (t.scrollLeft > 4) fig.classList.add("is-moved");
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { paint(c); });
    }, { passive: true });
  });

  /* ---- Filters, sort and search (as Shop All) ---- */
  var B = window.ALM_BB || {}, F = window.ALM_FACETS || {}, RANK = window.ALM_RANK || {};
  var MERGE = { white: "cream", peach: "orange", navy: "blue" }; // same merge as the collection filters
  var COLORS = (window.ALM_COLORS || []).filter(function (c) { return !MERGE[c[0]]; });
  var CMAP = {}; COLORS.forEach(function (c) { CMAP[c[0]] = c; });
  var known = {}; (window.ALM_COLORS || []).forEach(function (c) { known[c[0]] = 1; });
  var CUFFS = window.ALM_CUFFS || [], FMAP = {}; CUFFS.forEach(function (c) { FMAP[c[0]] = c; });
  var COLS = B.collections || [];
  var P = cards.map(function (c) {
    var h = c.getAttribute("data-h"), f = F[h] || {}, H = (c.getAttribute("data-hs") || "").split(" ");
    var c1 = c.getAttribute("data-c") || f.c || "multi"; if (!known[c1]) c1 = "multi";
    var c2 = c.getAttribute("data-c2") || f.c2 || ""; if (!known[c2]) c2 = "";
    c1 = MERGE[c1] || c1; c2 = MERGE[c2] || c2; if (c2 === c1) c2 = "";
    var cf = (c.getAttribute("data-cf") || "").split(" ").filter(Boolean);
    if (!cf.length) cf = f.cf || [];
    var r = RANK[h];
    return {
      el: c, h: h, t: c.getAttribute("data-t"), p: +c.getAttribute("data-p"), i: c._i,
      c: c1, c2: c2, cf: cf, u: r ? r[1] : -1,
      th: COLS.filter(function (x) { return H.indexOf(x.h) > -1; }).map(function (x) { return x.t; }),
      n: H.indexOf(B.newHandle) > -1, b: H.indexOf(B.bestHandle) > -1
    };
  });

  var S = { q: "", cols: {}, colors: {}, cuffs: {} }, SORT = "featured";
  function keys(o) { return Object.keys(o).filter(function (k) { return o[k]; }); }
  function match(p) {
    var ts = keys(S.cols), cs = keys(S.colors), fs = keys(S.cuffs);
    if (ts.length && !p.th.some(function (t) { return ts.indexOf(t) > -1; })) return false;
    if (cs.length && cs.indexOf(p.c) === -1 && (!p.c2 || cs.indexOf(p.c2) === -1)) return false;
    if (fs.length && !p.cf.some(function (c) { return fs.indexOf(c) > -1; })) return false;
    if (S.q) {
      var hay = (p.t + " " + p.th.join(" ") + " " + (CMAP[p.c] ? CMAP[p.c][1] : "") + " " +
        (p.c2 && CMAP[p.c2] ? CMAP[p.c2][1] : "") + " " + p.cf.join(" ")).toLowerCase();
      if (hay.indexOf(S.q) === -1) return false;
    }
    return true;
  }
  // Featured is Shop All's order: a new arrival with no sales yet leads, then
  // units sold in the last 90 days, then collection order.
  function rank(a, b) {
    var la = a.n && a.u < 1, lb = b.n && b.u < 1;
    if (la !== lb) return la ? -1 : 1;
    if (a.u !== b.u) return b.u - a.u;
    return a.i - b.i;
  }
  // Best selling follows Rebuy's live top sellers, as the homepage lane and
  // Shop All do (client, Oct 18: best seller 1:1 everywhere).
  var BEST = [];
  function at(p) { var i = BEST.indexOf(p.h); return i < 0 ? 1e6 : i; }
  function rebuyBest() {
    if (!window.AlmRebuy) return;
    AlmRebuy.handles("products/top_sellers", { limit: 60 }).then(function (h) {
      if (h && h.length) { BEST = h; if (SORT === "best") apply(); }
    }, function () {});
  }
  if (window.AlmRebuy) rebuyBest(); else document.addEventListener("DOMContentLoaded", rebuyBest);
  var SORTERS = {
    featured: rank,
    best: function (a, b) { if (a.b !== b.b) return a.b ? -1 : 1; return at(a) - at(b) || rank(a, b); },
    "new": function (a, b) { if (a.n !== b.n) return a.n ? -1 : 1; return rank(a, b); },
    "price-asc": function (a, b) { return a.p - b.p || rank(a, b); },
    "price-desc": function (a, b) { return b.p - a.p || rank(a, b); },
    name: function (a, b) { return a.t.localeCompare(b.t); }
  };

  // Only offer what the bundle actually holds.
  var has = { col: {}, c: {}, cf: {} };
  P.forEach(function (p) {
    p.th.forEach(function (t) { has.col[t] = 1; });
    has.c[p.c] = 1; if (p.c2) has.c[p.c2] = 1;
    p.cf.forEach(function (x) { has.cf[x] = 1; });
  });
  $("[data-bb-cols]").innerHTML = '<button type="button" class="bb-col" data-bb-col="" aria-pressed="true">All</button>' +
    COLS.filter(function (c) { return has.col[c.t]; }).map(function (c) {
      return '<button type="button" class="bb-col" data-bb-col="' + esc(c.t) + '" aria-pressed="false">' + esc(c.t) + "</button>";
    }).join("");
  $("[data-bb-colors]").innerHTML = COLORS.filter(function (c) { return has.c[c[0]]; }).map(function (c) {
    return '<button class="bb-swatch" type="button" data-bb-color="' + c[0] + '" aria-pressed="false"><span class="cc" style="background:' + esc(c[2]) + '"></span>' + esc(c[1]) + "</button>";
  }).join("");
  var cuffList = CUFFS.filter(function (c) { return has.cf[c[0]]; });
  $("[data-bb-cuffs]").innerHTML = cuffList.map(function (c) {
    return '<button class="bb-cuff" type="button" data-bb-cuff="' + esc(c[0]) + '" aria-pressed="false"><span class="bb-cuff-img"><img src="' + esc(c[2]) + '" alt="" loading="lazy"></span>' + esc(c[1]) + "</button>";
  }).join("");
  if (!cuffList.length) $("[data-bb-cuffgroup]").hidden = true;

  function chips() {
    var out = [];
    function add(kind, key, label) {
      out.push('<button type="button" class="bb-fchip" data-bb-chip="' + kind + '" data-key="' + esc(key) + '">' + esc(label) + " <span>&times;</span></button>");
    }
    keys(S.cols).forEach(function (k) { add("cols", k, k); });
    keys(S.colors).forEach(function (k) { add("colors", k, CMAP[k] ? CMAP[k][1] : k); });
    keys(S.cuffs).forEach(function (k) { add("cuffs", k, (FMAP[k] || [k, k])[1] + " cuff"); });
    if (S.q) out.push('<button type="button" class="bb-fchip" data-bb-chip="q" data-key="q">&ldquo;' + esc(S.q) + "&rdquo; <span>&times;</span></button>");
    if (out.length) out.push('<button type="button" class="bb-fchip is-clear" data-bb-reset>Clear all</button>');
    $("[data-bb-chips]").innerHTML = out.join("");
  }

  function apply() {
    var list = P.filter(match).sort(SORTERS[SORT] || rank);
    var shown = {};
    list.forEach(function (p) { shown[p.h] = 1; grid.appendChild(p.el); });
    P.forEach(function (p) { p.el.hidden = !shown[p.h]; });
    $("[data-bb-empty]").hidden = list.length > 0;
    $("[data-bb-count]").textContent = list.length + " pair" + (list.length === 1 ? "" : "s");
    $("[data-bb-done]").textContent = "Show " + list.length + " pair" + (list.length === 1 ? "" : "s");
    chips();
    var anyCol = keys(S.cols).length;
    $$("[data-bb-col]").forEach(function (b) {
      var k = b.getAttribute("data-bb-col");
      b.setAttribute("aria-pressed", k ? !!S.cols[k] : !anyCol);
    });
    $$("[data-bb-color]").forEach(function (b) { b.setAttribute("aria-pressed", !!S.colors[b.getAttribute("data-bb-color")]); });
    $$("[data-bb-cuff]").forEach(function (b) { b.setAttribute("aria-pressed", !!S.cuffs[b.getAttribute("data-bb-cuff")]); });
  }
  function reset() {
    S = { q: "", cols: {}, colors: {}, cuffs: {} };
    $("[data-bb-q]").value = "";
    apply();
  }

  // Filter drawer below 1181px, as Shop All's on phones.
  var lastFocus = null;
  function filters(on) {
    root.classList.toggle("bb-flt-open", on);
    document.documentElement.classList.toggle("bb-lock", on);
    $("[data-bb-fopen]").setAttribute("aria-expanded", on);
    if (on) { lastFocus = document.activeElement; var x = $(".bb-side-x"); if (x) x.focus(); }
    else if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  $("[data-bb-q]").addEventListener("input", function (e) { S.q = e.target.value.trim().toLowerCase(); apply(); });
  $("[data-bb-sort]").addEventListener("change", function (e) { SORT = e.target.value; apply(); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("bb-flt-open")) filters(false);
  });

  root.addEventListener("click", function (e) {
    var b = e.target.closest("button");
    if (!b || b.disabled) return;
    var card = b.closest("[data-bb-card]"), h = card && card.getAttribute("data-h");
    if (b.hasAttribute("data-bb-add") || b.hasAttribute("data-bb-inc")) {
      set(h, 1);
      // Keep focus on the card's control once + turns into the stepper.
      if (b.hasAttribute("data-bb-add")) { var inc = $("[data-bb-inc]", card); if (inc && !inc.disabled) inc.focus(); else $("[data-bb-dec]", card).focus(); }
    } else if (b.hasAttribute("data-bb-dec")) {
      set(h, -1);
      if (!pick[h]) $("[data-bb-add]", card).focus();
    } else if (b.hasAttribute("data-bb-pic")) show(card, +b.getAttribute("data-bb-pic"));
    else if (b.hasAttribute("data-bb-rm")) set(order[+b.getAttribute("data-bb-rm")], -1);
    else if (b.hasAttribute("data-bb-toggle")) tray(!root.classList.contains("bb-open"));
    else if (b.hasAttribute("data-bb-go")) submit(b);
    else if (b.hasAttribute("data-bb-col")) {
      var k = b.getAttribute("data-bb-col");
      if (!k) S.cols = {}; else S.cols[k] = !S.cols[k];
      apply();
    } else if (b.hasAttribute("data-bb-color")) { var c = b.getAttribute("data-bb-color"); S.colors[c] = !S.colors[c]; apply(); }
    else if (b.hasAttribute("data-bb-cuff")) { var f = b.getAttribute("data-bb-cuff"); S.cuffs[f] = !S.cuffs[f]; apply(); }
    else if (b.hasAttribute("data-bb-chip")) {
      var kind = b.getAttribute("data-bb-chip"), key = b.getAttribute("data-key");
      if (kind === "q") { S.q = ""; $("[data-bb-q]").value = ""; } else delete S[kind][key];
      apply();
    } else if (b.hasAttribute("data-bb-reset")) reset();
    else if (b.hasAttribute("data-bb-fopen")) filters(true);
    else if (b.hasAttribute("data-bb-fclose")) filters(false);
  });
  $(".bb-fscrim").addEventListener("click", function () { filters(false); });

  // The cart drawer's "You may also like" draws from the cards on the page,
  // as it does on Shop All.
  function reg() {
    if (!window.AlmCart || !AlmCart.register) return;
    AlmCart.register(P.map(function (p) {
      return { h: p.h, v: +p.el.getAttribute("data-v"), t: p.t, p: p.p, i: p.el.getAttribute("data-i").replace("width=160", "width=600"),
        g: p.th[0] || "", k: p.el.getAttribute("data-k"), s: false, b: p.b };
    }));
  }
  if (window.AlmCart) reg(); else document.addEventListener("DOMContentLoaded", reg);

  // The tray is pinned to the bottom on phones, so floating app widgets
  // (Klaviyo, Wishlist, accessibility) step above it as they do for the
  // product page's sticky bar.
  var phone = window.matchMedia("(max-width:900px)");
  function lift() { document.documentElement.classList.toggle("alm-sbar-on", phone.matches); document.documentElement.classList.toggle("bb-bar-on", phone.matches); }
  if (phone.addEventListener) phone.addEventListener("change", lift);
  lift();

  // Shopify's theme preview bar is pinned over the foot of the screen, where it
  // would cover the tray's Add button. While it shows, the tray sits on top of
  // it (--bb-pb). Shoppers never see that bar, so for them this stays 0.
  function pbar() {
    var w = document.getElementById("PBarNextFrameWrapper"), h = 0;
    if (w) {
      // The wrapper clips a full-height iframe, so its own box is the bar.
      var r = w.getBoundingClientRect(), cs = getComputedStyle(w);
      if (r.height && r.top < innerHeight && cs.display !== "none" && cs.visibility !== "hidden") h = Math.max(0, Math.round(innerHeight - r.top));
    }
    document.documentElement.style.setProperty("--bb-pb", Math.min(h, 120) + "px");
    return w;
  }
  if (!pbar() && window.MutationObserver) {
    var mo = new MutationObserver(function () { if (pbar()) { mo.disconnect(); watch(); } });
    mo.observe(document.body, { childList: true });
  } else watch();
  function watch() {
    var w = document.getElementById("PBarNextFrameWrapper");
    if (w && window.ResizeObserver) new ResizeObserver(pbar).observe(w);
    if (w && window.MutationObserver) new MutationObserver(pbar).observe(w, { attributes: true });
    addEventListener("resize", pbar);
    setTimeout(pbar, 1500);
  }

  apply();
  render();
})();
